import React from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from "@/lib/utils";
import { toast } from 'sonner';

interface ActionPhraseProps {
  text: string;
  categoryId?: string;
  categorySlug?: string;
  className?: string;
  rowIndex?: number;
}

const ActionPhrase = ({ text, categoryId, categorySlug, className, rowIndex }: ActionPhraseProps) => {
  const navigate = useNavigate();
  
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (categorySlug) {
      console.log(`Navigating to category: ${categorySlug}`);
      navigate(`/explore?category=${categorySlug}`, { replace: false });
    } else {
      console.log('No category slug found, navigating to explore page');
      navigate('/explore', { replace: false });
    }
  };

  const getHoverEffect = (index?: number) => {
    switch (index) {
      case 1: return 'hover:shadow-blue-500/25';
      case 2: return 'hover:shadow-purple-500/25';
      case 3: return 'hover:shadow-green-500/25';
      default: return 'hover:shadow-primary/25';
    }
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        "px-4 py-2 text-foreground transition-all duration-300",
        "hover:scale-105 hover:shadow-lg",
        getHoverEffect(rowIndex),
        "bg-background/40 backdrop-blur-sm rounded-lg",
        "border border-primary/10",
        "animate-fade-in text-sm md:text-base font-medium whitespace-nowrap",
        className
      )}
      aria-label={`Action: ${text}`}
    >
      {text}
    </button>
  );
};

export default ActionPhrase;
